<template>
    <div :class="getCSSClass('model-manager-details-container')">
        <div v-if="loading" v-html="loadingIndicator"></div>
        <template v-else>
            <div :class="getCSSClass('repository-manager-function-popup-header') + ' ' + getCSSClass('repository-manager-function-popup-blue-header')">
                <h2 :class="getCSSClass('repository-manager-function-popup-header-mainheader')">
                    <span v-html="icon('details')+' '+translate('Részletek')"></span>
                </h2>
            </div>

            <div v-for="label, field in details.fields"
                 :class="getCSSClass('model-manager-details-row')"
            >
                <div :class="getCSSClass('model-manager-details-column-first')">
                    <label v-html="label"></label>
                </div>
                <div :class="getCSSClass('model-manager-details-column-second')"
                     v-html="details.model[field]"
                >
                </div>
            </div>
        </template>
        <div :class="getCSSClass('repository-manager-popup-buttons-container')"
        >

            <button type="button"
                    :class="getCSSClass('repository-manager-popup-cancel-button')"
                    v-on:click="$emit('canceled')"
                    v-html="icon('close')+this.translate('Bezár')"></button>
        </div>

    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
        },
        data: function () {
            return {
                loading: true,
                details: null,
            }
        },
        mounted() {
            this.fetchDetails();
        },
        methods: {
            fetchDetails: function() {
                window.axios.get(this.operationsUrl)
                    .then((response) => {
                        this.details = response.data;
                        this.loading = false;
                    })
            },
        },
        computed: {},
        watch: {}

    }
</script>
